export const validateHiraganaKatakana = (text = '') => {
    return text.match('^[ぁ-ゔゞァ-・ヽヾ゛゜ー]+$')
}

/** True only for null, undefined, or empty string (whitespace-only is not treated as empty). */
const isEmptyOptional = text => text == null || String(text) === ''

/** Empty string, null, or undefined is valid; otherwise same rules as validateHiraganaKatakana. */
export const validateHiraganaKatakanaOptional = (text = '') => {
    const s = text == null ? '' : String(text)
    if (isEmptyOptional(text)) return true
    return !!validateHiraganaKatakana(s)
}

export const validateKanjiHiraganaKatakana = (text = '') => {
    if (text.split(' ').join('') === '') return false
    let result = true
    text.split('').forEach(char => {
        if (
            !char.match('^[一-龠ぁ-ゔゞァ-・ヽヾ゛゜ー]+$') &&
            !char.match(
                /([\u{3005}\u{3007}\u{303b}\u{3400}-\u{9FFF}\u{F900}-\u{FAFF}\u{20000}-\u{2FFFF}][\u{E0100}-\u{E01EF}\u{FE00}-\u{FE02}]?)/mu
            )
        ) {
            result = false
        }
    })
    return result
}

/** Empty string, null, or undefined is valid; otherwise same rules as validateKanjiHiraganaKatakana. */
export const validateKanjiHiraganaKatakanaOptional = (text = '') => {
    const s = text == null ? '' : String(text)
    if (isEmptyOptional(text)) return true
    return validateKanjiHiraganaKatakana(s)
}

export const validateNumbers = (text = '') => {
    return text.match('^[0-9]*$')
}
export const validateEmail = (text = '') => {
    const emailRegex = new RegExp(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9]+([.-][a-zA-Z0-9]+)*\.[a-zA-Z]{2,3}$/)
    if (emailRegex.test(text)) {
        return true
    }
    return false
}
export const validatePhone = (text = '') => {
    return text.match(/^[0-9]{9,11}$/)
}
export const validatePassword = (text = '') => {
    return text.match(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z]{10,}$/)
}

export const validateEmpCode = (text = '') => {
    const regex = /^[0-9\b]+$/
    return regex.test(text)
}

/** Empty string, null, or undefined is valid; otherwise digits only (same as validateEmpCode). */
export const validateDigitsOnlyOptional = (text = '') => {
    const s = text == null ? '' : String(text)
    if (isEmptyOptional(text)) return true
    return validateEmpCode(s)
}